import React from "react";
import "./message-popup.css";


const MessagePopup = ({
  count,
  onOpen,
  onClose
}) => {


  if (!count)
    return null;



  return (

    <div className="message-popup-overlay">


      <div className="message-popup">


        <div className="popup-icon">
          📩
        </div>


        <h2>
          پیام جدید دارید
        </h2>


        <p>
          شما
          {" "}
          <b>{count}</b>
          {" "}
          پیام خوانده نشده دارید.
        </p>



        <div className="popup-actions">


          <button
            className="popup-open"
            onClick={onOpen}
          >

            ورود به صندوق پیام

          </button>



          <button
            className="popup-close"
            onClick={onClose}
          >

            نادیده گرفتن

          </button>


        </div>


      </div>


    </div>

  );

};


export default MessagePopup;